import { apiService } from "./api.js";

const BASE_URL_TRACK = process.env.REACT_APP_API_TRACK;
const BASE_URL_TRACK_AUTH = process.env.REACT_APP_API_TRACK_AUTH;
const MIDDLEWARE_CLIENT = process.env.REACT_APP_CLIENT_ID;
const MIDDLEWARE_SECRET = process.env.REACT_APP_SECRET;
const UAT_MIDDLEWARE_SECRET = process.env.REACT_APP_UAT_SECRET;
const REACT_APP_API_MAIN = process.env.REACT_APP_API_MAIN;
const REACT_APP_API_CUSTOMER_APP = process.env.REACT_APP_API_CUSTOMER_APP;

const apiCall = {
  allbranchesApi: (header = undefined) => {
    return new apiService().get("Locations/GetAllBranches", header);
  },
  middlewareAuthToken: (header = undefined) => {
    return new apiService().bridgeApiAUTH(
      `/auth?ClientID=${MIDDLEWARE_CLIENT}&ClientSecret=${MIDDLEWARE_SECRET}`,
    );
  },

  uatmiddlewareAuthToken: (header = undefined) => {
    return new apiService().emailbridgeApiAUTH(
      `/auth?ClientID=${MIDDLEWARE_CLIENT}&ClientSecret=${UAT_MIDDLEWARE_SECRET}`,
    );
  },

  sendEmail: (body, header = undefined) => {
    return new apiService().bridgeApiEmail(`sendemail`, header, body);
  },

  insertPickup: (body, header = undefined) => {
    return new apiService().bridgeApiPickup(`insertpickup`, header, body);
  },
  getTarif: (body, header = undefined) => {
    return new apiService().bridgeApiTarif(`gettarif`, header, body);
  },
  getTarifInt: (body, header = undefined) => {
    return new apiService().bridgeApiTarifInt(`gettarifint`, header, body);
  },
  getCity: (header = undefined) => {
    return new apiService().bridgeApiCities(`getcities`, header);
  },
  getIntCountries: (header = undefined) => {
    return new apiService().bridgeApiIntCities(`getintcountries`, header);
  },
  getServices: (header = undefined) => {
    return new apiService().bridgeApiServices(`getservices`, header);
  },
  createecomlead: (body, header = undefined) => {
    return new apiService().bridgeApiEcom(`createEcomLead`, header, body);
  },
  createRcodLead: (body, header = undefined) => {
    return new apiService().bridgeApiRcod(`createRcodLead`, header, body);
  },
  getBranchesByCity: (header = undefined) => {
    return new apiService().basicBridgeApi(`getbranchesbycity`, header);
  },

  getAreaCode: (header = undefined) => new apiService().bridgeApiArea(header),

  trackApiNew: (header = undefined) => {
    return new apiService().bridgeApi(`trackapinew`, header);
  },
};

export default apiCall;
